import { QuestionLabel } from '@/pages/onboarding/QuestionLabel';
import type { OnboardingStepProps } from '@/pages/onboarding/onboarding.types';
import { CONSULTATION_OPTIONS, matchOption } from '@/pages/onboarding/onboardingOptions';
import type { ConsultationType } from '@/types/onboarding';
import { ChoiceCard, ChoiceCardCheckboxGroup, Grid, Icon, Stack } from '@careflux/primitives';
import { Controller } from 'react-hook-form';

const CONSULTATION_TYPES = CONSULTATION_OPTIONS.map((option) => option.value);

const toConsultationTypes = (values: string[]): ConsultationType[] =>
  values.flatMap((value) => matchOption(CONSULTATION_TYPES, value) ?? []);

export const ConsultationTypesField = ({ copy, control }: OnboardingStepProps) => (
  <Controller
    name="consultationTypes"
    control={control}
    render={({ field }) => (
      <Stack gap="sm">
        <QuestionLabel id="consultation-label" hint={copy.work.consultationHint} hintId="consultation-hint">
          {copy.work.consultationQuestion}
        </QuestionLabel>
        <Grid asChild columns={{ base: 2, sm: 4 }} gap="sm">
          <ChoiceCardCheckboxGroup
            aria-labelledby="consultation-label"
            aria-describedby="consultation-hint"
            indicator="check"
            value={field.value}
            onValueChange={(values) => field.onChange(toConsultationTypes(values))}
          >
            {CONSULTATION_OPTIONS.map(({ value, icon }) => (
              <ChoiceCard
                key={value}
                id={`consultation-${value}`}
                value={value}
                label={copy.work.consultationTypes[value]}
                icon={<Icon name={icon} />}
              />
            ))}
          </ChoiceCardCheckboxGroup>
        </Grid>
      </Stack>
    )}
  />
);
